const KILOMETRO = 1;
const METRO = KILOMETRO / 1000.0;

export const abreModalLocalizacao = () => ({type: 'ABRE_MODAL_LOCALIZACAO'});
export const fechaModalLocalizacao = () => ({type: 'FECHA_MODAL_LOCALIZACAO'});
export const loadingGeolocation = (loading) => ({ type: 'LOADING_GEOLOCATION', loading });
export const fetchGeolocationSuccess = (coordenadas) => ({ type: 'FETCH_GEOLOCATION_SUCCESS', coordenadas });
export const setCoordenadas = (coordenadas) => ({ type: 'SET_COORDENADAS', coordenadas });
export const setRaio = (raio) => ({ type: 'SET_RAIO', raio });
export const fetchGeolocationError = (error) => ({ type: 'FETCH_GEOLOCATION_ERROR', error });
export const getGeolocation = () => (dispatch) => {
  if (navigator.geolocation) {
    dispatch(loadingGeolocation(true));
    navigator.geolocation.getCurrentPosition(
      position => {
        const {latitude, longitude} = position.coords;
        dispatch(fetchGeolocationSuccess([ latitude, longitude ]));
        dispatch(loadingGeolocation(false));
      },
      error => {
        dispatch(fetchGeolocationError('The Geolocation service failed'));
        dispatch(loadingGeolocation(false));
      }
    );
  } else {
    dispatch(fetchGeolocationError('Error: Your browser doesn\'t support geolocation.'));
  }
};
export const atualizaLocalizacao = (endereco, raio, unidade) => (dispatch) => {
  raio = +raio * (unidade === 'km' ? KILOMETRO : METRO);
  dispatch(setCoordenadas([endereco.lat, endereco.lng]));
  dispatch(setRaio(raio));
}



// WEBPACK FOOTER //
// ./src/actions/geolocation.js